import React from "react";
import { Box, Skeleton } from "@mui/material";

const ProgramTypeMetricsSkeleton = () => {
  return (
    <Box>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={4}
        py={3}
        borderBottom={2}
        borderColor="grey.200"
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              width: "4px",
              height: "20px",
              bgcolor: "grey.300",
            }}
          />
          <Skeleton variant="text" width={160} height={28} />
        </Box>

        {/* Optional Month Filter Button */}
        {/* <Skeleton variant="rectangular" width={70} height={28} sx={{ borderRadius: 1 }} /> */}
      </Box>

      {/* Donut Chart Skeleton */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        py={5}
      >
        <Skeleton
          variant="circular"
          width={240}
          height={240}
          sx={{ bgcolor: "grey.200" }}
        />
      </Box>
    </Box>
  );
};

export default ProgramTypeMetricsSkeleton;
